import useSWR from 'swr'
import { endpoints, request } from '.'

export const useProductDetails = () => {
  const { data, isLoading, isValidating, error } = useSWR(
    endpoints.dataAccount.get(),
    request
  )
  return {
    productInfo: data?.data?.data?.attributes?.productDetails,
    isLoading,
    isValidating,
    error,
  }
}
